import React from 'react'

import i18n from 'live/services/i18n'

import {
    IBarrier,
    IBowtie,
    IConsequence,
    IEscalationFactor,
    IHazard,
    IThreat,
    ITopEvent
} from 'plugin-codaf-risk-ext-bowtie/types'

import { DraggableModal } from '../DraggableModal/DraggableModal'
import { ListCard, EntityErrorScrollbars } from './styled'

interface IProps {
    onClose: () => void
    show: boolean
    errorsList: IListItemError[]
}

export type IErrorTypes =
    | 'HAZARD'
    | 'TOPEVENT'
    | 'THREAT'
    | 'CONSEQUENCE'
    | 'BARRIER'
    | 'ESCALATIONFACTOR'
    | 'ESCALATIONBARRIER'

export type IListItemError = {
    type: IErrorTypes
    name: string
    errors: string
    onEdit?: () => void
}

export type IItemTypes =
    | IHazard
    | ITopEvent
    | IThreat
    | IConsequence
    | IBarrier
    | IEscalationFactor
    | IBarrier
    | IBowtie

export interface IError {
    type: IErrorTypes
    item: IItemTypes
    name: string
    errors: string
    onEdit?: () => void
}

export const EntityErrorModal: React.FC<IProps> = ({ onClose, show, errorsList }) => {
    return (
        <DraggableModal
            onClose={onClose}
            show={show}
            height={284}
            width={600}
            header={i18n('Entities with errors')}
            closeButton
        >
            <EntityErrorScrollbars height={284}>
                {errorsList.map(({ type, name, errors, onEdit }, idx) => {
                    return (
                        <ListCard key={idx} className="custom-card-wrapper">
                            <div className={`custom-card ${onEdit ? 'clickable' : 'non-clickable'}`} onClick={onEdit}>
                                <div className={`custom-card-border ${type}`} />
                                <div className="custom-card-content">
                                    <div className="custom-card-header">
                                        <div className="custom-card-title">{name || '-'}</div>
                                    </div>
                                    <div className="custom-card-description">{errors}</div>
                                </div>
                            </div>
                        </ListCard>
                    )
                })}
            </EntityErrorScrollbars>
        </DraggableModal>
    )
}
